(function() { window.GUID_0eb05a1a_bdd9_476b_bf2d_355fb7a305b2 = { getGuid: function() { return "0eb05a1a-bdd9-476b-bf2d-355fb7a305b2"; } }; })();
var CS;
(function (CS) {
    class Connection {
        static Create() {
            if (!this.Current) {
                this.Current = new Connection();
            }
        }
        get InternetIsBad() {
            return this.onlineStatusIsBad || this.googleConnectionIsBad;
        }
        constructor() {
            this.googlePingTimeOut = 25000;
            CS.Connection.Current = this;
            this.onlineStatusIsBad = false;
            this.googleConnectionIsBad = false;
            window.addEventListener('online', () => {
                /*Je ne clanche pas ConnectionSucceed puisqu'il est possible que online soit bon mais pas l'access au web, donc,
                 *cest pourquoi je passe par ConnectionProblemDetected() qui lui fera d'autre vérifications*/
                this.TestConnections();
            });
            window.addEventListener('offline', () => {
                this.TestConnections();
            });
            this.TestConnections();
        }
        TestConnections() {
            clearTimeout(this.ajaxCallTimer);
            this.onlineStatusIsBad = !navigator.onLine;
            this.pingGoogle();
        }
        ConnectionSucceed() {
            let me = this;
            this.onlineStatusIsBad = false;
            this.googleConnectionIsBad = false;
            clearTimeout(this.ajaxCallTimer);
            this.connectionStatusChanged();
        }
        connectionStatusChanged() {
            CS.DOM.$body.toggleClass('connection-problem', this.InternetIsBad);
        }
        pingGoogle() {
            let me = this;
            let googleTimer = null;
            let img = new Image();
            let onFinished = function (fail) {
                clearTimeout(googleTimer);
                me.googleConnectionIsBad = fail;
                me.connectionStatusChanged();
                try {
                    document.body.removeChild(img);
                }
                catch (e) {
                }
            };
            img.onload = function () {
                onFinished(false);
            };
            img.onerror = function () {
                onFinished(true);
            };
            googleTimer = setTimeout(() => {
                onFinished(true);
            }, me.googlePingTimeOut);
            img.src = 'https://www.google.com/favicon.ico';
            img.style.position = "absolute";
            img.style.top = "-1000px";
            img.style.opacity = '0';
            if (document.body) {
                document.body.appendChild(img);
            }
        }
    }
    CS.Connection = Connection;
})(CS || (CS = {}));

//# sourceMappingURL=cs-connection.pre.js.map
